import React from 'react';

const CheckoutEmailSection = ({ sendEmail, emailAddresses, onChange }) => {
  return (
    <div className="checkout-email-section">
      <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: 600 }}>Email Notification</h3>
      
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: sendEmail ? '12px' : '0',
        cursor: 'pointer'
      }}>
        <input
          type="checkbox"
          name="sendEmail"
          checked={sendEmail}
          onChange={onChange}
          style={{
            width: '16px',
            height: '16px',
            cursor: 'pointer'
          }}
        />
        <span style={{ fontSize: '13px', color: '#4a5568', fontWeight: 500 }}>
          Send Email
        </span>
      </label>

      {sendEmail && (
        <div className="form-group" style={{ marginTop: '12px' }}>
          <label htmlFor="emailAddresses">Enter Email Address</label>
          <textarea
            id="emailAddresses"
            name="emailAddresses"
            value={emailAddresses}
            onChange={onChange}
            placeholder="Enter one or multiple email addresses (comma-separated)"
            rows="3"
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '2px solid #e2e8f0',
              borderRadius: '6px',
              fontSize: '13px',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
          <small style={{ color: '#718096', fontSize: '11px', marginTop: '4px', display: 'block' }}>
            Separate multiple emails with commas (e.g., email1@example.com, email2@example.com)
          </small>
        </div>
      )}
    </div>
  );
};

export default CheckoutEmailSection;
